import { useQuery } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Alert, Loader } from '@pocketlaw/tetris';
import { TeamsAndUsersMenu } from 'app/domains/common-ui';
import { RequestVVoluntarySelectApproversDocument } from './SelectApprovers.gql';
export function SelectApprovers(props) {
    const { approvers, teamApprovers, buttonAppearance, onAddApprover, onAddTeamApprover, onRemoveApprover, onRemoveTeamApprover, } = props;
    const { data, loading, error } = useQuery(RequestVVoluntarySelectApproversDocument);
    const selectedApproverUserIds = approvers.map((approver) => approver.userId);
    const selectedApproverTeamIds = teamApprovers.map((teamApprover) => teamApprover.teamId);
    const selectTeam = (team) => {
        const isSelected = selectedApproverTeamIds.includes(team.id);
        if (isSelected) {
            onRemoveTeamApprover(team.id);
        }
        else {
            onAddTeamApprover({
                teamId: team.id,
                name: team.name,
                members: team.members,
            });
        }
    };
    const selectUser = (user) => {
        const isSelected = selectedApproverUserIds.includes(user.userId);
        if (isSelected) {
            onRemoveApprover(user.userId);
        }
        else {
            onAddApprover(user);
        }
    };
    const handleSelect = (item) => {
        if (item.type === 'team') {
            selectTeam(item.team);
        }
        else {
            selectUser(item.user);
        }
    };
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please reload the page and try again',
                comment: 'Manage template approvers - select approvers field - failed to load data to display',
            })}/>);
    }
    return (<TeamsAndUsersMenu type="all" from={data || {}} selectedIds={[...selectedApproverTeamIds, ...selectedApproverUserIds]} onSelect={handleSelect} renderTarget={<Button type="button" size="small" appearance={buttonAppearance}>
          {loading && <Loader />}
          <Trans comment="Manage template approvers - select approvers field - select approvers button label">
            Select approvers
          </Trans>
        </Button>}/>);
}
